export default __webpack_public_path__ + "static/media/money_exchange.94adecf5.png";